export default __webpack_public_path__ + "static/media/weekend.59f1151f.webp";